import { useSelector } from "react-redux";
import { FormattedMessage } from 'react-intl';
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../hooks/hooks";
import { selectCurrent } from "../../../../../redux/settings/selectors";
import { selectEmailAccountsListItems } from "../../../../../redux/email-accounts/selector";
import { emailAccounts } from "../../../../../redux/email-accounts/action";
import Table from "../../../../../common/components/table";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../components/PageLoader";


const ManagementEmailAccounts = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
	const result = useSelector(selectCurrent)
	const { header, footer, currency } = result
    const emailAccountItems = useSelector(selectEmailAccountsListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'Email', headerName: 'Email' },
          { field: 'DisplayName', headerName: 'DisplayName' }
      
        ]);
      }
      const fetchEmailAccounts =()=>{

        dispatch(emailAccounts.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/email-accounts/list`,entity:'emailAccounts',jsonData:{
          "PageNumber": pageData,
             "PageSize": 10,
             "SortField": "Id",
             "SortOrder": "desc",}
         }));
       
      }
	useEffect(() => {
        createColumnDefs()
        fetchEmailAccounts()
	}, [pageData])

  const handleAdd=()=>{
    navigate(`${0}`)
  }
  const handleEdit=(data: any)=>{
    navigate(`${data?.Id}`)
  }

  const additionButtons: any = [
    {
      name: 'Add EmailAccount',
      callback: () => handleAdd(),
    }
  ];
  const handleDelete=(data: any)=>{
    dispatch(emailAccounts.delete({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/email-accounts/delete`,
      entity: 'emailAccounts',
      jsonData: {
          Records: [
              {
                  Id: data?.Id
              }
          ]
      }
  })).then(() => {
    dispatch(emailAccounts.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/configuration/email-accounts/list`,entity:'emailAccounts',jsonData:{
          "PageNumber": pageData,
             "PageSize": 10,
             "SortField": "Id",
             "SortOrder": "desc",}
         }));
  });
  } 
	return (
    <>
    {emailAccountItems?.isLoading ? 
    <PageLoader />
:   
		<Table columnData={columnDefs} rowData={emailAccountItems?.result?.items} setPageData={setPageData}
    paginationData={emailAccountItems?.result?.pagination} onEdit={handleEdit} onDelete={handleDelete} additionButtons={additionButtons} headingName="Email Accounts" />
  }
  </> 
     
	);
};

export default ManagementEmailAccounts;


